import {API, Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const ALL_GROUP_STATISTICS_KEY = 'ALL';
export const NONE_GROUP_STATISTICS_KEY = 'NONE_GROUP';

export interface IHomeWorkStatistic {
    submittedForReview: number;
    approved: number;
    retakeRequired: number;
    rejected: number;
}

export type THomeWorkStatisticsByGroup = Record<string, IHomeWorkStatistic>;

interface IFilter {
    projectId?: string,
    themeId?: string,
    teacherId?: string
}

export const getUncheckedCount = (statistic?: IHomeWorkStatistic | null) => statistic?.submittedForReview || 0;

export const useGetHomeWorksStatistics = (request: IFilter, t?: number, disabled?: boolean) => {
    const [resp, setResp] = useState<THomeWorkStatisticsByGroup | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!request?.projectId || !request?.themeId || !request?.teacherId || disabled) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetHomeWorksStatistics')
            .get()
            .addQuery('moduleProjectId', request?.projectId)
            .addQuery('themeLongreadId', request?.themeId)
            .addQuery('teacherId', request?.teacherId)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                if (r?.status === 400 || r?.status === 403) {
                    return;
                }
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [request?.projectId, request?.themeId, request?.teacherId, t, disabled])

    return {statistics: resp, isLoading, error};
}
import {API, Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const ALL_GROUP_STATISTICS_KEY = 'ALL';
export const NONE_GROUP_STATISTICS_KEY = 'NONE_GROUP';

export interface IHomeWorkStatistic {
    submittedForReview: number;
    approved: number;
    retakeRequired: number;
    rejected: number;
}

export type THomeWorkStatisticsByGroup = Record<string, IHomeWorkStatistic>;

interface IFilter {
    projectId?: string,
    themeId?: string,
    teacherId?: string
}

export const getUncheckedCount = (statistic?: IHomeWorkStatistic | null) => statistic?.submittedForReview || 0;

export const useGetHomeWorksStatistics = (request: IFilter, t?: number, disabled?: boolean) => {
    const [resp, setResp] = useState<THomeWorkStatisticsByGroup | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!request?.projectId || !request?.themeId || !request?.teacherId || disabled) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetHomeWorksStatistics')
            .get()
            .addQuery('moduleProjectId', request?.projectId)
            .addQuery('themeLongreadId', request?.themeId)
            .addQuery('teacherId', request?.teacherId)
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                if (r?.status === 400 || r?.status === 403) {
                    return;
                }
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [request?.projectId, request?.themeId, request?.teacherId, t, disabled])

    return {statistics: resp, isLoading, error};
}
